var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2023 24.882C10.6571 24.882 10.1922 24.6809 9.80732 24.2788C9.42232 23.8766 9.22982 23.3812 9.22982 22.7927H13.1756C13.1756 23.3812 12.983 23.8766 12.5977 24.2788C12.2125 24.6809 11.7474 24.882 11.2023 24.882ZM7.39947 21.2942V19.7636H15.006V21.2942H7.39947ZM7.51405 18.288C6.45393 17.5965 5.60387 16.7308 4.96389 15.691C4.3239 14.6514 4.00391 13.4764 4.00391 12.1662C4.00391 10.2182 4.71486 8.53133 6.13676 7.10576C7.55882 5.68019 9.24617 4.96741 11.1988 4.96741C13.1516 4.96741 14.8424 5.68019 16.2712 7.10576C17.7001 8.53133 18.4146 10.2182 18.4146 12.1662C18.4146 13.4728 18.0983 14.6469 17.4658 15.6885C16.8335 16.73 15.9753 17.5965 14.8914 18.288H7.51405ZM8.16466 16.4725H14.2676C14.9832 15.9943 15.5486 15.3781 15.9637 14.6238C16.3786 13.8695 16.5861 13.0513 16.5861 12.169C16.5861 10.6892 16.0584 9.42371 15.003 8.3726C13.9474 7.32133 12.6807 6.7957 11.2027 6.7957C9.72475 6.7957 8.45799 7.32133 7.40245 8.3726C6.34706 9.42371 5.81936 10.6892 5.81936 12.169C5.81936 13.0513 6.0289 13.869 6.44797 14.6222C6.86719 15.3755 7.43942 15.9923 8.16466 16.4725Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5039 2.86194H10.0039V0.117956H11.5039V2.86194Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2598 11.6198V10.1198H21.9998V11.6198H19.2598Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 11.6198V10.1198H2.74789V11.6198H0.00390625Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9448 6.00893L15.8965 4.93604L17.8592 3.01839L18.9074 4.09129L16.9448 6.00893Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96734 6.00893L6.01562 4.93604L4.05295 3.01839L3.00467 4.09129L4.96734 6.00893Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/Bulb.c752fc45890f6abea81e770235fdda73.svg";
export { ForwardRef as ReactComponent };